var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"next-button",style:(_vm.style),attrs:{"src":require("../assets/arrow.png"),"alt":"next"}})
}
var staticRenderFns = []

export { render, staticRenderFns }